<template>
	<div>
    <div class="popup_high_right tracking-codes-popup"
         :class="['level-'+level,{}]">
      <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <div class="layout-row flex-none">
		            <h3 class="title" >
			            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
			            Tracking codes
			            <span></span>
		            </h3>
	            </div>

	            <template v-if="codes.length>0">
	            <div class="flex-none layout-row flex-center margin-b-10">
		            <p style="line-height: 150%">
			            Generally, we do not recommend over-using external codes.<br>
			            However, if you had to use any, make sure to enable lazy loading,
			            to prevent them from negatively impacting your pages' loading speed.
		            </p>
		            <div class="flex margin-r-15"></div>
		            <v-button class="create-btn" label="Create a new code" slim @click="createCodeOpen=true"/>
	            </div>

	            <div class="layout-column flex">
		            <Container @drop="onDrop" lock-axis="y">
				            <tracking-code-entry v-for="(code,index) in codes" :key="code.id" :code="code"
				                                 :index="index" @click="currentCode=code;editCodeOpen=true" />
		            </Container>
	            </div>
	            </template>
	            <template v-else>
		            <div class="flex layout-column flex-center">
			            <p class="" style="text-align: center;line-height: 160%">
				            Generally, we do not recommend over-using external codes.<br>
				            However, if you had to use any external codes make sure to enable lazy loading,
				            to prevent them from negatively impacting your pages' loading speed.
			            </p>
			            <v-button class="create-btn margin-t-10" label="Create a new code" slim
			                      @click="createCodeOpen=true"/>
			            <div class="flex"></div>
		            </div>
	            </template>
	            <div style="min-height: 50px"></div>
            </div>
        </div>

			<popup-backdrop v-if="createCodeOpen" @close="createCodeOpen=false">
				<create-tracking-codes-popup :level="level+1" @close="createCodeOpen=false"
				                             @done="createCodeOpen=false" :funnel-id="funnelId" />
			</popup-backdrop>

		<popup-backdrop v-if="editCodeOpen" @close="editCodeOpen=false">
			<edit-tracking-codes-popup :level="level+1" @close="editCodeOpen=false"
                         @done="editCodeOpen=false" :funnel-id="funnelId" :code-id="currentCode?currentCode.id:0"  />
		</popup-backdrop>

	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import numbers from "@/helpers/numbers";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import {mapGetters} from "vuex";
import TrackingCodeEntry from "@/views/funnels/funnel-plus/funnel/tracking_codes/tracking_code_entry";
import CreateTrackingCodesPopup from "@/views/funnels/funnel-plus/funnel/tracking_codes/create_tracking_code_popup";
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag } from '@/helpers/sort'
import EditTrackingCodesPopup from "@/views/funnels/funnel-plus/funnel/tracking_codes/edit_tracking_code_popup";

export default {
	name: "TrackingCodesPopup",
	title: "Funnel tracking codes | Funnelish™",
	mixins: [API],
	components: {
		EditTrackingCodesPopup,
		Container, Draggable,
		CreateTrackingCodesPopup,
		TrackingCodeEntry,
		QuickActionsBtn,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			createCodeOpen:false,
			editCodeOpen:false,
			codeOpen: false,
			saving: false,
			menuLoading: false,
			loading: false,
			currentCode: {},
		}
	},
	computed:{
		...mapGetters(['setCodesStore','getCodesStore']),
		// localDate(){
		// 	return moment(this.order.created_at).format("DD MMMM YYYY, HH:mm:ss")
		// },
		codes(){
			return this.getCodesStore;
		}
	},
	methods: {
		async onDrop(dropResult) {
			if(dropResult.removedIndex !== dropResult.addedIndex) {
				let codes = applyDrag(this.codes, dropResult);
				let first = codes[dropResult.removedIndex];
				let second = codes[dropResult.addedIndex];

				let firstOrder = first.order_index;
				let secondOrder = second.order_index;

				first.order_index = secondOrder;
				second.order_index = firstOrder;

				codes.forEach((item, index) => {
					item.order_index = index;
					this.api.codes.updateIndex(item);
				})

				this.$store.dispatch("setCodesStore", codes)
			}
		},

		closePopup() {
			this.$emit('close')
		},

		//API
		// async init() {
		// 	try {
		// 		this.loading = true;
		// 		this.codes = [];
		//
		// 		this.codes = await this.api.codes.get(this.funnelId);
		// 		this.$store.dispatch("setCodesStore", this.codes)
		// 	} catch (e) {
		// 		this.$error(e);
		// 	} finally {
		// 		this.loading = false;
		// 	}
		// },
	},
	created() {
		// this.init();
	},
}
</script>
<style lang="scss" scoped>
.tracking-codes-popup {
	padding: 0;
	.create-btn {
		min-width: auto;
		white-space: nowrap;
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
